// Route guard that redirects non-admin roles to /dashboard when they
// attempt to access /admin/* pages via direct URL (BUG-10).

import { Navigate, Outlet } from "react-router-dom";
import { useRole } from "@/role";
import { capabilitiesFor } from "@/role/capabilities";

export function RequireAdmin(): JSX.Element {
  const { currentRole, status } = useRole();
  const caps = capabilitiesFor(currentRole);

  // While role is still resolving, render nothing — the RolePickerModal
  // will handle the "pending" state.
  if (status === "resolving" || status === "pending") {
    return <Outlet />;
  }

  if (!caps.canSeeAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
